module.exports = __webpack_public_path__ + "img/gw.c1e88a91.svg";